import axios from 'axios';
import AxiosUtil from '../utils/axiosUtil';
import { BaseService } from './BaseService';

const BASE_URI = '/apis/partners';
export const PartnerService = (function () {
  let instance;
  const baseService = BaseService.getInstance(BASE_URI, 'partners');

  function init() {
    return {
      ...baseService,
      register: async function (data) {
        return await AxiosUtil.Async.post(BASE_URI, data);
      },
      update: async function (data) {
        return await AxiosUtil.Async.put(BASE_URI, data);
      },
      list: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');

        return AxiosUtil.Async.get(BASE_URI, queryString);
      },
      getData: async function (partnerId) {
        return AxiosUtil.Async.get(BASE_URI + `/${partnerId}`);
      },
      delete: async function (partnerId) {
        return (await AxiosUtil.Async.delete(BASE_URI + `/${partnerId}`)).data;
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();

export const Partner = {
  postPartner: async (data) => {
    const result = await AxiosUtil.Async.post(`${BASE_URI}`, data);
    return result.data;
  },

  nearList: async (data) => {
    const result = await axios.get(`${BASE_URI}/search`, {
      params: data,
    });
    return result.data;
  },
};
